// Math converters

// takes a base 10 and returns a 2 digit number
export function baseTenToSixteen(n:number):string{
    let letter= (n:number)=>{
        switch (n){
            case 10: return "A";
            case 11: return "B";
            case 12: return "C";
            case 13: return "D";
            case 14: return "E";
            case 15: return "F";
            default: return n.toString()
        }
    }

    return ""+letter(Math.floor(n/16))+""+letter(n%16)
}

// Takes a two digit hex and returns base 10
export function baseSixteenToTen(n:string):number{
    let letter = (n:string)=>{
        switch (n){
            case "A": return 10;
            case "B": return 11;
            case "C": return 12;
            case "D": return 13;
            case "E": return 14;
            case "F": return 15;
            default: return Number(n);
        }
    }


    if(!(n.length===2)){
        throw new Error("Number wrong size: "+n)
    }

    let baseTen: number = 0

    baseTen += letter(n[0].toUpperCase())*16;
    baseTen += letter(n[1].toUpperCase());

    return baseTen
}